import type Cookies from "js-cookie";

export class CookieConfigDTO {
  name: string;
  value: string | object;
  attributes?: Cookies.CookieAttributes;

  constructor(params: Partial<CookieConfigDTO>) {
    this.name = params.name ?? "";
    this.value = params.value ?? "";
    this.attributes = params.attributes || {};
  }
}
